import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Popover from 'modules/core/components/PopoverMenu'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import type Membership from 'modules/teams/store/models/Membership'

interface Props {
  membership: Membership
  readonly?: boolean
}

const Settings = ({ membership, readonly }: Props) => {
  const onClickMemberPromote = () => {
    return asyncAction(() =>
      membership.save({
        lead: true,
      })
    )
  }

  const onClickMemberRemove = () => {
    asyncAction(() => membership.destroy())
  }

  const renderSettings = () => {
    if (readonly) return null

    return (
      <Popover type="list">
        <Popover.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </Popover.Trigger>
        <Popover.Content side="bottom" align="center">
          <Popover.TouchableOption
            title={i18n.t('teams.promote_to_leader')}
            onClick={onClickMemberPromote}
          />
          <Popover.TouchableOption
            danger
            title={i18n.t('teams.remove_from_team')}
            onClick={onClickMemberRemove}
          />
        </Popover.Content>
      </Popover>
    )
  }

  return renderSettings()
}

export default observer(Settings)
